import DefaultFactory from "/scripts/default/factory";
import CoreHero from "/components/core/hero";
import CoreIntro from "/components/core/intro";
import CoreAccessibility from "/components/core/accessibility";
import CoreFree from "/components/core/free";
import CoreConnect from "/components/core/connect";
import CoreSequence from "/components/core/sequence";
import CoreAnimate from "/components/core/animate";

/*
	Individual page factories follow the same principles as
	the global factory in /public/scripts/index.js but contain
	blocks that should only be checked for on a single page
*/
class CoreFactory extends DefaultFactory {
	createBlock(blockName, block) {
		switch (blockName) {
			case "core-hero":
				return new CoreHero(block);
			case "core-intro":
				return new CoreIntro(block);
			case "core-accessibility":
				return new CoreAccessibility(block);
			case "core-free":
				return new CoreFree(block);
			case "core-connect":
				return new CoreConnect(block);
			case "core-sequence":
				return new CoreSequence(block);
			case "core-animate":
				return new CoreAnimate(block);
			default:
				return null;
		}
	}
}

new CoreFactory();
